/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ItemResponseType } from './ItemResponseType';
import {
    ItemResponseTypeFromJSON,
    ItemResponseTypeFromJSONTyped,
    ItemResponseTypeToJSON,
    ItemResponseTypeToJSONTyped,
} from './ItemResponseType';

/**
 * 
 * @export
 * @interface PortalItemResponseInput
 */
export interface PortalItemResponseInput {
    /**
     * 
     */
    response: ItemResponseType;
    /**
     * 
     */
    note?: string | null;
    /**
     * Who has it, for someone_else_has_it
     */
    other_contact?: string | null;
}



/**
 * Check if a given object implements the PortalItemResponseInput interface.
 */
export function instanceOfPortalItemResponseInput(value: object): value is PortalItemResponseInput {
    if (!('response' in value) || value['response'] === undefined) return false;
    return true;
}

export function PortalItemResponseInputFromJSON(json: any): PortalItemResponseInput {
    return PortalItemResponseInputFromJSONTyped(json, false);
}

export function PortalItemResponseInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalItemResponseInput {
    if (json == null) {
        return json;
    }
    return {
        
        'response': ItemResponseTypeFromJSON(json['response']),
        'note': json['note'] === undefined ? undefined : json['note'] === null ? null : json['note'],
        'other_contact': json['other_contact'] === undefined ? undefined : json['other_contact'] === null ? null : json['other_contact'],
    };
}

export function PortalItemResponseInputToJSON(json: any): PortalItemResponseInput {
    return PortalItemResponseInputToJSONTyped(json, false);
}

export function PortalItemResponseInputToJSONTyped(value?: PortalItemResponseInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'response': ItemResponseTypeToJSON(value['response']),
        'note': value['note'],
        'other_contact': value['other_contact'],
    };
}

